import styled from 'styled-components';
import { crTheme } from '@comicrelief/component-library';
import {
  Main,
  DesktopLogo,
  ContentWrapper,
  BackgroundImage,
  BaseOuterContainer,
  BaseInnerContainer,
  BaseSmallAndMediumHeader,
} from './shared.style';

// DonateLayout-specific interfaces extending base ones
interface SecureTextAndIconProps {
  $mobile?: boolean;
}

// DonateLayout-specific styled components
const SmallAndMediumHeader = styled(BaseSmallAndMediumHeader)`
  background: ${props => (props.$isJourneySelectPage ? crTheme.color('white') : crTheme.color('grey_light'))};
  border-bottom: ${props => (props.$isJourneySelectPage ? 'none' : `1px solid ${crTheme.color('grey_medium')}`)};
`;

const OuterContainer = styled(BaseOuterContainer)`
  background-color: ${props => (props.$desktopbackgroundcolour  ? `${crTheme.color(props.$desktopbackgroundcolour)}` : `${crTheme.color('black')}`)};
`;

const InnerContainer = styled(BaseInnerContainer)`
  @media ${crTheme.allBreakpoints('M')} {
    background-color: ${crTheme.color('white')};
    border-radius: 1rem;
    margin: 3rem auto;
    width: calc(100% - 60px);
    max-width: 564px;
  }
  @media ${crTheme.allBreakpoints('L')} {
    margin: 3rem auto 0;
  }
`;

const SecureWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const SecureIcon = styled.img.attrs({
  src: '/assets/images/lock.svg',
  alt: 'Secure donation icon'
})<SecureTextAndIconProps>`
  width: 12px;
  height: 12px;
  filter: ${props => (props.$mobile ? 'none' : 'brightness(0) invert(1)')};
`;

const SecureText = styled.span<SecureTextAndIconProps>`
  font-family: montserrat;
  font-size: 0.75rem;
  color: ${props => (props.$mobile ? crTheme.color('grey_dark') : crTheme.color('grey_light'))};
  font-weight: 700;
`;

const SecureTextAndIcon = styled(SecureWrapper)<SecureTextAndIconProps>``;

const SecureTextAndIconDesktopWrapper = styled(SecureWrapper)`
  display: none;
  z-index: 2;
  @media ${crTheme.allBreakpoints('L')} {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 6rem;
    margin-top: 0;
    background-color: transparent;
  }
`;

export {
  Main,
  SmallAndMediumHeader,
  DesktopLogo,
  OuterContainer,
  InnerContainer,
  ContentWrapper,
  BackgroundImage,
  SecureWrapper,
  SecureIcon,
  SecureText,
  SecureTextAndIcon,
  SecureTextAndIconDesktopWrapper
};
